<template>
  <div>
    <div class="loading" v-if="is_loading">
      <div class="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div>
      <div id="idc-container">
        <div id="idc-header" class="w-100">
          <div class="app-main d-flex align-items-center">
            <img src="@/assets/images/ilogo.png" class="mt-0-8" style="margin-bottom: 8px;margin-left: 10px;" />
            <el-menu class="ml-auto menu border-0" mode="horizontal">
              <el-dropdown trigger="click" class="menubar-xs">
                <div class="el-dropdown-link hover p-1">
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span class="el-dropdown language">
                      <i class="idc-icons mr-0-8" :class="locale === 'vi' ? 'icon-flag-en' : 'icon-flag-vi'"></i>
                      {{locale === 'vi' ? $t('languageEn') : $t('languageVi')}}
                      <i class="el-icon-arrow-down el-icon--right ml-0-8"></i>
                    </span>
                    <div class="ml-1">
                      <span class="d-flex align-items-center" @click="setLocale('en')">
                        <i class="idc-icons icon-flag-en"></i>
                        {{$t('languageEn')}}
                      </span>
                      <span class="d-flex align-items-center" @click="setLocale('vi')">
                        <i class="idc-icons icon-flag-vi"></i>
                        {{$t('languageVi')}}
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span class="el-dropdown">
                      <i class="el-icon-user el-icon--right mx-0"></i>
                      <span class="text-limited user p-0">Khách hàng</span>
                      <i class="el-icon-arrow-down el-icon--right mx-0"></i>
                    </span>
                    <div class="ml-1">
                      <router-link :to="{name: 'login'}"><i class="el-icon-user el-icon--right mx-0"></i> {{$t('auth.login.btn')}}</router-link>
                      <router-link :to="{name: 'register'}"><i class="el-icon-money el-icon--right mx-0"></i> {{$t('auth.register.btn')}}</router-link>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="menubar-lg">
                <el-menu-item>
                  <el-dropdown trigger="click">
                  <span class="el-dropdown">
                    <i class="idc-icons" :class="locale === 'en' ? 'icon-flag-en' : 'icon-flag-vi'"></i>
                    {{locale === 'en' ? $t('languageEn') : $t('languageVi')}}

                    <i class="el-icon-arrow-down el-icon--right mx-0"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                      <span class="d-flex align-items-center" @click="setLocale('en')">
                        <i class="idc-icons icon-flag-en"></i>
                        {{$t('languageEn')}}
                      </span>
                      </el-dropdown-item>
                      <el-dropdown-item @click="setLocale('vi')">
                      <span class="d-flex align-items-center" @click="setLocale('vi')">
                        <i class="idc-icons icon-flag-vi"></i>
                        {{$t('languageVi')}}
                      </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-menu-item>
                <el-menu-item>
                  <el-dropdown trigger="click">
                    <div class="el-dropdown">
                      <i class="el-icon-user el-icon--right mx-0"></i>
                      <span class="text-limited user">Khách hàng</span>
                      <i class="el-icon-arrow-down el-icon--right mx-0"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">

                      <el-dropdown-item>
                        <router-link :to="{name: 'login'}"><i class="el-icon-user el-icon--right mx-0"></i> {{$t('auth.login.btn')}}</router-link>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <router-link :to="{name: 'register'}"><i class="el-icon-money el-icon--right mx-0"></i> {{$t('auth.register.btn')}}</router-link>
                      </el-dropdown-item>
                    
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-menu-item>
              </div>
            </el-menu>
          </div>
        </div>
        <div class="app-main py-2 px-1" :class="'local-' + locale">
          <router-view :key="key" />
        </div>
      </div>
      <footer class="text-center">
        <span>IDC Online Cloud Portal</span>
        <span>Hotline: 19006452</span>
        <span>Email: support@idconline.vn</span>
      </footer>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  export default {
    props: ['currentPage'],
    data () {
      return {
        locale: localStorage.locale,
        is_loading: true
      }
    },
    computed: {
      key () {
        return this.$route.path
      }
    },
    methods: {
      setLocale (locale) {
        this.$emit('setLocale', locale)
        localStorage.locale = locale
        this.locale = _.cloneDeep(locale)
      }
    },
    mounted () {
      this.is_loading = false
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/idc/index2.vue